export default "__VITE_ASSET__B23I9$kl__"